import { MASTER_WHITELABEL_ID } from '../constants/whitelabel.constants';
import {
  hasEnabledPermission,
  MeProfile,
} from '../services/profile/me-profile.model';

export const USAGE_METRICS_PERMISSION = 'can_see_usage_metrics';

export const USAGE_METRICS_ROUTE = '/configuracoes/gerenciamento/metricas-uso';

type UsageMetricsViewer = MeProfile | null | undefined;

const isCameritePlatform = (me: UsageMetricsViewer): boolean =>
  me?.whitelabel?.id === MASTER_WHITELABEL_ID;

const isPlatformAdmin = (me: UsageMetricsViewer): boolean =>
  me?.admin === true || me?.masterAdmin === true;

export const canSeeUsageMetricsItem = (me: UsageMetricsViewer): boolean =>
  isCameritePlatform(me);

export const canGrantUsageMetrics = (me: UsageMetricsViewer): boolean =>
  isCameritePlatform(me) && isPlatformAdmin(me);

export const canSeeUsageMetrics = (me: UsageMetricsViewer): boolean =>
  isCameritePlatform(me) &&
  (isPlatformAdmin(me) || hasEnabledPermission(me, USAGE_METRICS_PERMISSION));
